import { Show } from "solid-js/web";
import { infoGreyIcom } from "~/assets/assets";
import { getConsistentDay, getOrdinalDay } from "~/utils/date";
import { useDenominationGridContext } from "../context/denomination_grid_context";

export function TransactionAdditionalInfo() {
  const { externalProps } = useDenominationGridContext();
  const { isCoinsOnly, offerConstruct } = externalProps;
  return (
    <>
      <Show when={!isCoinsOnly && !offerConstruct}>
        <div class="inline-flex items-center justify-center gap-1 self-stretch">
          <div class=" text-medium text-textDark">Safe & secure payment</div>
          <img
            class="h-4 w-20"
            src={
              "https://gullak-assets.s3.ap-south-1.amazonaws.com/icons/razorpay-trust-marker.png"
            }
            alt="Secure payments"
          />
        </div>
      </Show>
      <Show when={offerConstruct?.type === "SUBSCRIPTION_REWARD"}>
        <div class="mt-1 flex items-start gap-1">
          <img src={infoGreyIcom} alt="" />
          <p class="text-f12 text-textNormal">
            You'll get one gift card now, and the rest on the{" "}
            {`${getOrdinalDay(getConsistentDay(new Date()))}`} each month.
          </p>
        </div>
      </Show>
    </>
  );
}
